/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

/**
 * stripMarkdown — Remove Markdown formatting for natural TTS output.
 *
 * Strips headers, bold/italic, links, images, code blocks, inline code,
 * bullet markers, blockquotes, horizontal rules, and HTML tags.
 */

export default function stripMarkdown(md: string): string {
  if (!md) return '';

  return (
    md
      // Code blocks (``` … ```)
      .replace(/```[\s\S]*?```/g, '')
      // Inline code
      .replace(/`([^`]+)`/g, '$1')
      // Images ![alt](url)
      .replace(/!\[.*?\]\(.*?\)/g, '')
      // Links [text](url) → text
      .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
      // Headers ### text → text
      .replace(/^#{1,6}\s+/gm, '')
      // Bold **text** or __text__
      .replace(/\*\*(.+?)\*\*/g, '$1')
      .replace(/__(.+?)__/g, '$1')
      // Italic *text* or _text_
      .replace(/\*(.+?)\*/g, '$1')
      .replace(/_(.+?)_/g, '$1')
      // Strikethrough ~~text~~
      .replace(/~~(.+?)~~/g, '$1')
      // Blockquotes
      .replace(/^>\s?/gm, '')
      // Unordered list markers (-, *, +)
      .replace(/^[\s]*[-*+]\s+/gm, '')
      // Ordered list markers (1. 2. etc)
      .replace(/^[\s]*\d+\.\s+/gm, '')
      // Horizontal rules
      .replace(/^[-*_]{3,}\s*$/gm, '')
      // HTML tags
      .replace(/<[^>]+>/g, '')
      // Emoji shortcodes :emoji: → ""
      .replace(/:[a-zA-Z0-9_+-]+:/g, '')
      // Collapse multiple newlines
      .replace(/\n{3,}/g, '\n\n')
      .trim()
  );
}
